<template>
  <div class="swiper_banner" v-if="reportArray.length != 0">
    <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide v-for="(item,index) in reportArray" :key="index">
        <div class="slide_img" @click="currentReport(item)">
          <div class="banner_img_box" :class="[item.fileName == currentData.fileName?'active_bg':'']">
            <div class="banner_img_box_text">
              <p class="title"  :class="[language == 'zh'?'zhFamily':'enfamily']">{{item.fileInfo}}  </p>
              <!-- <div class="info">{{item.fileInfo}}</div> -->
            </div>
            <img class="banner_img" :src="`${GLOBAL.imageUrl}${item.cover}`" alt="image" />
          </div>
        </div>
      </swiper-slide>
    </swiper>

    <div class="swiper-button-prev">
      <i class="iconfont icon-jiantou2"></i>
    </div>
    <div class="swiper-button-next">
      <i class="iconfont icon-jiantou"></i>
    </div>
    <!-- <div class="pagination_box">
      <div class="swiper-pagination"></div>
    </div>-->
  </div>
</template>

<script>
// 引入插件
import bus from "@/bus";
import { swiper, swiperSlide, Pagination } from "vue-awesome-swiper";
import {
  swiperAnimateCache,
  swiperAnimate
} from "@/assets/js/swiper.animate1.0.3.min.js";
import "swiper/dist/css/swiper.css";
export default {
  name: "Home",
  props: ["reportArray","currentData"],
  components: {
    swiper,
    swiperSlide,
    Pagination
  },
  watch: {
    reportArray() {
    }
  },
  data() {
    return {
      swiperOption: {
        loop: false,
        slidesPerView: 3,
        centeredSlides: false,
        longSwipes: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },

        autoplay: {
          delay: 900000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        // // 显示分页
        // pagination: {
        //   el: ".swiper-pagination",
        //   clickable: true //允许分页点击跳转
        // },

        on: {
          init: function() {
            swiperAnimateCache(this);
            swiperAnimate(this);
          },
          slideChangeTransitionStart: function() {},
          slideChangeTransitionEnd: function() {},
          slideChange: function() {
            swiperAnimate(this);
          }
        }
      }
    };
  },
  methods: {
    initSwiper() {
      this.$refs.mySwiper.update();
    },

    currentReport(item) {
      bus.$emit("reportEmit", item);
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  mounted() {}
};
</script>

<style lang="scss" >
.swiper_banner {
  //   width: 100%;
  padding: 6px 54px 8px;
  position: relative;
  overflow: hidden;
  height: 220px;
  .swiper-slide {
    // margin: 0 6px;
  }
  .swiper {
    --swiper-theme-color: #ff6600; /* 设置Swiper风格 */
    --swiper-navigation-color: #00ff33; /* 单独设置按钮颜色 */
    --swiper-navigation-size: 30px; /* 设置按钮大小 */
  }

  /*去掉默认样式*/
  .swiper-button-prev:after {
    display: none;
  }
  .swiper-button-next:after {
    display: none;
  }
  /*自定义样式*/
  .swiper-button-prev {
    width: 32px;
    height: 32px;
    background: #ccc;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.3);
    display: flex;

    justify-items: center;
    align-content: center;
    &:hover {
      background: rgba(0, 0, 0, 0.7);
    }
    &:hover i {
      color: #fff !important;
    }
  }

  .swiper-button-next {
    width: 32px;
    height: 32px;
    background: #ccc;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.3);
    display: flex;
    flex-direction: row;
    justify-items: center;
    align-content: center;
    &:hover {
      background: rgba(0, 0, 0, 0.7);
    }
    &:hover i {
      color: #fff !important;
    }
  }
  i {
    margin-top: 8px;
    width: 20px;
    height: 20px;
    display: block;
    color: #999;
  }
  .icon-jiantou {
    margin-left: 8px;
  }
  .icon-jiantou2 {
    margin-left: 6px;
  }
  .swiper-container {
    width: 100%;
    height: 100%;
  }
  .active_slide_img {
    z-index: 33 !important;
    opacity: 0.4 !important;
    transition-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
  }

  .slide_img:hover .banner_img_box::after {
    z-index: 33 !important;
    opacity: 0.3 !important;
    transition-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
  }
  .slide_img {
    width: 100%;
    height: 100%;
    padding: 0 10px;
    cursor: pointer;
      .active_bg::after {
     z-index: 33 !important;
    opacity: 0.3 !important;
    transition-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
  }
    .banner_img_box {
      position: relative;
      width: 100%;
      height: 100%;
      .banner_img_box_text {
        position: absolute;
        bottom: 10px;
        left: 10px;
        right: 10px;
        z-index: 999;
        color: #fff;
        .title {
          //   word-wrap: pre-wrap;
          word-wrap: break-word;
          font-size: 16px;
          font-weight: 600;
        }
      }
      &::after {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-image: linear-gradient(
          to bottom,
          rgba(0, 0, 0, 0.3),
          rgba(0, 0, 0, 1)
        );
        transition: opacity 0.3s cubic-bezier(0.35, 0.085, 0.68, 0.53);
        z-index: 99;
      }
      .banner_img {
          object-fit: cover;
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>